<template>
  <ion-page>
    <ion-header>
      <ion-grid fixed style="padding: 0">
        <ion-toolbar>
          <ion-title>{{ t('notifications') }}</ion-title>
        </ion-toolbar>
      </ion-grid>
    </ion-header>
    <ion-content :fullscreen="true">
      <ion-grid fixed>
        <!-- Loading Data -->
        <ion-list v-if="loading">
          <ion-item v-for="index in 10" :key="index">
            <ion-thumbnail slot="start">
              <ion-skeleton-text></ion-skeleton-text>
            </ion-thumbnail>
            <ion-label>
              <h3>
                <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
              </h3>
              <p>
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
              </p>
              <p>
                <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
              </p>
            </ion-label>
          </ion-item>
        </ion-list>

        <!-- Data loaded -->
        <ion-list v-else>
          <ion-item v-for="notification in allNotifications" :key="notification.id" :router-link="{
              name: 'NotificationDetailPage',
              params: { id: notification.id }
            }" button detail>
            <ion-thumbnail slot="start" v-if="notification.photo">
              <img :src="notification.photoLink">
            </ion-thumbnail>
            <ion-icon :icon="notificationsOutline" slot="start" v-else></ion-icon>
            <ion-label>
              <h3>
                {{ notification.title }}
              </h3>
              <p>{{ notification.content }}</p>
              <p><small>{{ getRelativeDate(notification.scheduledToSendAt) }}</small></p>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
// Vue reactivity
import { computed, ref } from 'vue';

// icons
import { notificationsOutline } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonGrid, IonList, IonItem, IonLabel, IonIcon,
        IonThumbnail, IonButtons, IonButton, IonBadge,
        IonSkeletonText, IonChip } from '@ionic/vue';

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { utils } from '@/composables/utils';

export default {
  name: 'NotificationListPage',
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage,
                IonGrid, IonList, IonItem, IonLabel, IonIcon,
                IonThumbnail, IonButtons, IonButton, IonBadge,
                IonSkeletonText, IonChip, },
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const { getRelativeDate } = utils();

    // 1. declare state variables (ref to make them reactive)
    const loading = computed(() => store.state.loadingNotifications);
    const allNotifications = computed(() => store.state.allNotifications);

    // 3. return variables & methods to be used in template HTML
    return {
      // methods
      t, getRelativeDate,

      // icons
      notificationsOutline,

      // variables
      loading, allNotifications,
    }
  }
}
</script>